export enum authModalTabs {
  login="login",
  signup="signup",
}

export type IAuthPopupProps = {
  tab?: authModalTabs;
}
